/*
 * Package Import
 */
import styled from '@emotion/styled';
import { Link as RouterLink } from 'react-router-dom';

/*
 * Local Import
 */
import { colors, breakpoints, medias, utils, weights } from 'src/themes';
import button from 'assets/files/images/home/boutonPixel.svg';

/*
 * Components
 */
export const Container = styled.div({
  padding: '8em 2em 5em',
});

export const Title = styled.h2({
  fontWeight: weights.black,
  letterSpacing: '.12em',
  font: `${weights.normal} 2em/1.3 Quicksand`,
  textAlign: 'center',
  textTransform: 'uppercase',
  padding: '2em 2em 1em',

  /* @medias */
  [medias.maxWidth(breakpoints.iphone6s)]: {
    fontSize: '1.6em',
  },

  [medias.betweenWidth(breakpoints.xs, breakpoints.m)]: {
    fontSize: '1.4em',
  },
  [medias.maxWidth(breakpoints.s)]: {
    padding: '2em 0.5em 1em',
  },
});

export const Highlight = styled.span({
  color: colors.momentumOrange,
});

export const SubTitle = styled.div({
  margin: '0 auto',
  maxWidth: '52em',
  textAlign: 'center',

  [medias.maxWidth(breakpoints.xl)]: {
    padding: '0 10%',
    width: '100%',
  },
  [medias.maxWidth(breakpoints.m)]: {
    padding: '0',
    fontSize: '0.9em',
  },
});

export const LogoContainer = styled.div({
  display: 'flex',
  justifyContent: 'space-around',
  margin: '4em auto',
  maxWidth: '30em',

  [medias.maxWidth(breakpoints.m)]: {
    flexDirection: 'column',
    alignItems: 'center',
    margin: 0,
  },
});

export const Logo = styled.img({
  width: '10em',

  [medias.maxWidth(breakpoints.m)]: {
    margin: '2em 0 1em 0',
  },
});

export const Cta = styled(RouterLink)({
  ...utils.backSvgFill(button),
  color: 'white',
  margin: '3em auto 0',
  width: '12em',
  height: '3em',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  textTransform: 'uppercase',
  fontWeight: weights.bold,

  [medias.maxWidth(breakpoints.s)]: {
    width: '10em',
    height: '2.5em',
  },
});
